'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _badge = require('./badge.js');

var _badge2 = _interopRequireDefault(_badge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _badge2['default'];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/_components/@alicd/next-badge/lib/index.js
// module id = 323
// module chunks = 0